module.exports = {"330624001":"羽林街道","330624002":"南明街道","330624003":"七星街道","330624101":"澄潭镇","330624102":"梅渚镇","330624104":"回山镇","330624106":"大市聚镇","330624107":"小将镇","330624108":"沙溪镇","330624109":"镜岭镇","330624110":"儒岙镇","330624200":"城南乡","330624201":"东茗乡","330624203":"双彩乡","330624205":"新林乡","330624206":"巧英乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330624.json
// module id = 994
// module chunks = 0